// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8c4a6fc3","118":"02915161","260":"6dc9662b","430":"a703922d","453":"9f4f2f0b","582":"cf873cc7","593":"0ba5c431","933":"4daecc08","954":"d760812e"}[chunkId] + ".chunk.js";
};